import React from 'react';
import WYSIWYGArea from 'components/TextArea/WYSIWYGArea';

interface IDescriptionField {
	changeShortDescription: (value: string) => void;
	shortDescription: string;
}

const DescriptionField: React.FC<IDescriptionField> = ({ changeShortDescription, shortDescription }) => {
	return <WYSIWYGArea onChange={changeShortDescription} value={shortDescription} testId="DescriptionField" />;
};

export default React.memo(DescriptionField);
